import {
    buildSubCategoryTKey,
    BuildSubCategoryTKeyParameters,
    buildNestedSubCategoryTKey,
    BuildNestedSubCategoryTKeyParameters,
} from '../server';
import { safeTranslate, SafeTranslateOptions } from '../utils/safeTranslate';

export interface TranslateSubCategoryOptions {
    subCategoryId: BuildSubCategoryTKeyParameters['0'];
    subCategoryAttribute?: BuildSubCategoryTKeyParameters['1'];
    options?: Omit<SafeTranslateOptions, 'key'>;
}

/**
 * Translate subCategory name. Default attribute is `name`.
 */
export const translateSubCategory = ({
    subCategoryId,
    subCategoryAttribute,
    options,
}: TranslateSubCategoryOptions) =>
    safeTranslate({
        key: buildSubCategoryTKey(subCategoryId, subCategoryAttribute),
        ...options,
    });

interface TranslateNestedSubCategoryOptions {
    subCategoryId: BuildNestedSubCategoryTKeyParameters['0'];
    nestedSubCategoryId: BuildNestedSubCategoryTKeyParameters['1'];
    nestedSubCategoryAttribute?: BuildNestedSubCategoryTKeyParameters['2'];
    options?: Omit<SafeTranslateOptions, 'key'>;
}

/**
 * Translate nested subCategory. Default attribute is `name`.
 */
export const translateNestedSubCategory = ({
    subCategoryId,
    nestedSubCategoryId,
    nestedSubCategoryAttribute,
    options,
}: TranslateNestedSubCategoryOptions) =>
    safeTranslate({
        key: buildNestedSubCategoryTKey(
            subCategoryId,
            nestedSubCategoryId,
            nestedSubCategoryAttribute
        ),
        ...options,
    });
